import { observer } from 'mobx-react-lite';
import { React, useState, useEffect, useRef } from 'react';
import AppState from '../../js/AppState';
import Button from "../shared/Button/Button"

import './ScreenIntro.css';

import Texts from 'react-sdk/Texts';
import SpeechDisplayer from '../Personnage/SpeechDisplayer/SpeechDisplayer';
import Personnages from 'react-sdk/Personnage/Personnages';
import { pickRandom } from 'react-sdk/utils';


const ScreenIntro = () => {

  // const character = Personnages.get(PresentationHelper.getFirstSpeaker().id);


  const [anim, setAnim] = useState(null);

  useEffect(() => {
    setAnim(pickRandom(window.CONFIG.homeAttitudes))

    let animLoopInterval = setInterval(() => setAnim(pickRandom(window.CONFIG.homeAttitudes)), 11000)
    return(() => {
      clearInterval(animLoopInterval)
    })

  }, [])

  useEffect(() => {
    // mj.startAnim("bla bla bla bla", anim, null, null, null)
  }, [anim])

  return (
    <div className="ScreenIntro">
      {/* <img className='mask' src={mask} /> */}
      {/* <img className='mj' src={mj_home} /> */}

      <div className="mj">
        {/* <SpeechDisplayer character={character} /> */}
      </div>

      <div className="content">
        <div className="logo" />
        <div className="title" dangerouslySetInnerHTML={{ __html: Texts.get("module-title") }} />
        <div className="description" dangerouslySetInnerHTML={{ __html: Texts.get("module-description") }} />
      </div>

      <Button className="play-button" children={Texts.get("play-button")} onClick={() => AppState.launchModule()} />
    </div>
  );
};

export default  observer(ScreenIntro)
